export default class Busca {
  "use strict"

  constructor(modal, btnAbrir, btnFechar) {
    this.modal = modal;
    this.btnAbrir = btnAbrir;
    this.btnFechar = btnFechar;

    this.abrirModal();
    this.fecharModal();
  }

  /* Abrir modal ao clicar em btnAbrir */
  abrirModal = function () {
    this.btnAbrir.forEach(btn => {

      btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.modal.classList.add('visivel')
      })

    })
  }

  /* Fechar modal ao clicar em btnFechar */
  fecharModal = function () {

    this.btnFechar.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.modal.classList.remove('visivel')
      })
    });


  }
}
